export const getLocationFromState = (state) => {
    if (state.router?.location) {
        return state.router.location;
    }

    if (state.routing?.location) {
        return state.routing.location;
    }

    if (state.routing?.locationBeforeTransitions) {
        return state.routing.locationBeforeTransitions;
    }

    return {
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash
    };
};

export const getLocationPathname = (state) => {
    const location = getLocationFromState(state);
    return location?.pathname || window.location.pathname;
};
